// export.ts — CSV export of the closet (all local; nothing leaves the device).
// One row per garment with its computed inventory facts (descriptive only).

import type { Garment } from "./store";
import { costPerWearCents, daysDormant, formatCents, titleCase } from "./store";

function cell(v: string | number): string {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
function csv(headers: string[], rows: (string | number)[][]): string {
  return [headers, ...rows].map((r) => r.map(cell).join(",")).join("\n");
}

/** Full CSV: Item, Brand, Category, Colour, Price, Bought, Wears, Cost per wear, Last worn, Days dormant. */
export function garmentsCsv(garments: Garment[]): string {
  return csv(
    ["Item", "Brand", "Category", "Colour", "Price", "Bought", "Wears", "Cost per wear", "Last worn", "Days dormant"],
    garments.map((g) => {
      const cpw = costPerWearCents(g);
      const dorm = daysDormant(g);
      return [
        g.item,
        g.brand,
        titleCase(g.category),
        titleCase(g.color),
        g.price_cents > 0 ? formatCents(g.price_cents) : "",
        g.purchased_on,
        g.wear_count,
        cpw === null ? "" : formatCents(cpw),
        g.last_worn_on,
        dorm === null ? "" : String(dorm),
      ];
    }),
  );
}

export function buildExport(garments: Garment[]): { csv: string; filename: string } {
  const stamp = new Date().toISOString().slice(0, 10);
  return { csv: garmentsCsv(garments), filename: `oriora-closet-${stamp}.csv` };
}
